import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, Lock, FileText } from 'lucide-react';
export function ClosingSection() {
  const handlePurchaseClick = () => {
    try {
      if (window.fbq) {
        window.fbq('track', 'AddToCart', {
          content_name: 'Método Operativo Definitivo',
          content_type: 'product',
          value: 6.39,
          currency: 'USD'
        });
      }
    } catch (err) {
      // silently fail
    }
    // Delay navigation to let pixel fire
    setTimeout(() => {
      window.open('https://pay.hotmart.com/O103881166A?checkoutMode=10', '_blank');
    }, 350);
  };
  return <section id="pricing" className="py-24 px-5 relative bg-gradient-to-b from-[#0a0a0f] to-[#050508] border-t border-white/5" data-id="element-43">
      <div className="max-w-4xl mx-auto" data-id="element-44">
        <div className="glass-card rounded-3xl p-8 md:p-12 relative overflow-hidden border-[#00d4ff]/20" data-id="element-45">
          {/* Glow effect */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-gradient-to-b from-[#00d4ff]/10 to-transparent pointer-events-none" data-id="element-46" />

          <div className="grid md:grid-cols-2 gap-12 items-center relative z-10" data-id="element-47">
            {/* Product Mockup Representation */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="relative aspect-[4/5] bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl border border-white/10 shadow-2xl flex flex-col items-center justify-center p-6" data-id="element-48">
              <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiPgo8cmVjdCB3aWR0aD0iOCIgaGVpZ2h0PSI4IiBmaWxsPSIjZmZmIiBmaWxsLW9wYWNpdHk9IjAuMDIiLz4KPC9zdmc+')] mix-blend-overlay rounded-2xl" data-id="element-49"></div>

              <FileText className="w-16 h-16 text-[#00d4ff] mb-6" data-id="element-50" />
              <h3 className="text-2xl font-bold text-center mb-2" data-id="element-51">
                Método Operativo Definitivo
              </h3>
              <p className="text-gray-400 text-sm text-center mb-8" data-id="element-52">
                PDF Interactivo + Guías Bonus
              </p>

              <div className="w-full h-2 bg-gray-800 rounded-full overflow-hidden" data-id="element-53">
                <div className="w-1/3 h-full bg-gradient-to-r from-[#00d4ff] to-[#7c3aed]" data-id="element-54"></div>
              </div>
            </motion.div>

            {/* Pricing & CTA */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="flex flex-col" data-id="element-55">
              <h2 className="text-3xl font-bold mb-6" data-id="element-56">
                Instala el Sistema Hoy
              </h2>

              <div className="flex items-end gap-4 mb-8" data-id="element-57">
                <div className="flex flex-col" data-id="element-58">
                  <span className="text-gray-500 line-through text-lg" data-id="element-59">
                    Precio Original: $97
                  </span>
                  <div className="flex items-start gap-1" data-id="element-60">
                    <span className="text-2xl font-bold text-[#00d4ff] mt-1" data-id="element-61">
                      $
                    </span>
                    <span className="text-6xl font-extrabold text-white tracking-tight" data-id="element-62">
                      6.39
                    </span>
                  </div>
                </div>
                <div className="bg-green-500/20 text-green-400 text-xs font-bold px-2 py-1 rounded border border-green-500/30 mb-2" data-id="element-63">
                  Ahorras $90.61
                </div>
              </div>

              <a href="https://pay.hotmart.com/O103881166A?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="w-full" data-id="element-64">
                <Button fullWidth className="mb-6 py-5 text-xl" onClick={handlePurchaseClick} data-id="element-65">
                  INSTALAR EL SISTEMA AHORA
                </Button>
              </a>

              <div className="flex items-center justify-center gap-2 text-sm text-gray-400 mb-8" data-id="element-66">
                <Lock className="w-4 h-4" data-id="element-67" />
                <span data-id="element-68">Pago 100% seguro y encriptado</span>
              </div>

              {/* Guarantee */}
              <div className="bg-[#1a1a24] rounded-xl p-5 border border-white/5 flex gap-4 items-start" data-id="element-69">
                <ShieldCheck className="w-8 h-8 text-[#00d4ff] shrink-0" data-id="element-70" />
                <div data-id="element-71">
                  <h4 className="font-bold text-white mb-1" data-id="element-72">
                    Garantía de 7 Días
                  </h4>
                  <p className="text-sm text-gray-400 leading-relaxed" data-id="element-73">
                    Si en 7 días no has creado un clon más real que tus fotos de
                    Instagram, te devuelvo cada centavo. Sin preguntas.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>

        <div className="mt-12 text-center text-gray-600 text-sm" data-id="element-74">
          <p data-id="element-75">
            © {new Date().getFullYear()} Método Operativo. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </section>;
}